import React from "react";
import { skillsData } from "../config/personalInfo";

const SkillCard = ({ skill }) => (
  <div className="bg-white/80 backdrop-blur-sm rounded-xl p-4 shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 hover:bg-blue-50/80 group">
    <div className="text-center">
      <span className="text-lg font-medium text-gray-800 group-hover:text-blue-600 transition-colors duration-300">
        {skill}
      </span>
    </div>
  </div>
);

const CategorySection = ({ category }) => (
  <div className="bg-white/50 backdrop-blur-sm rounded-2xl p-6 shadow-lg">
    <div className="flex items-center gap-3 mb-6 pb-2 border-b-2 border-blue-500/30">
      <span className="text-3xl" role="img" aria-label="category icon">
        {category.icon}
      </span>
      <h3 className="text-2xl font-bold text-gray-800">{category.title}</h3>
    </div>
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
      {category.skills.map((skill, skillIndex) => (
        <SkillCard key={skillIndex} skill={skill} />
      ))}
    </div>
  </div>
);

const Skills = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            <span className="border-b-4 border-blue-500 pb-2">Skills</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Technologies and tools I work with
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-2">
          {skillsData.categories.map((category, index) => (
            <CategorySection key={index} category={category} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Skills;

// Add this to your global CSS or tailwind.config.js
// @keyframes fadeIn {
//   from { opacity: 0; transform: translateY(20px); }
//   to { opacity: 1; transform: translateY(0); }
// }
// .animate-fade-in {
//   animation: fadeIn 0.6s ease-out forwards;
// }
